/**
 * Copyright 2020 ExpediaGroup. All rights reserved.
 * EXPEDIA PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

const ErrorCodes = Object.freeze({
  RESPONSE_INVALID_DUPLICATE_ITINERARY: {
    header: 'InProgress',
    body: ['ResponseInvalidDuplicateItinerary'],
  },
  RESPONSE_INVALID_UNKNOWN: 'ResponseInvalidUnknown',
  RESPONSE_INVALID_ITINERARY_NOT_FOUND: 'ResponseInvalidItineraryNotFound',
  RESPONSE_INVALID_TRIP_MORE_THAN_SEVEN_DAYS:
    'ResponseInvalidTripMoreThanSevenDays',
  RESPONSE_INVALID_TRIP_IS_LCC: 'ResponseInvalidTripIsLcc',
  RESPONSE_INVALID_TRIP_IS_TICKETLESS: 'ResponseInvalidTripIsTicketless',
  RESPONSE_INVALID_ITINERARY: 'ResponseInvalidItinerary',
  RESPONSE_INVALID_STATUS: 'ResponseInvalidStatus',
  RESPONSE_INVALID_EMAIL: 'ResponseInvalidEmail',
  RESPONSE_INVALID_PHONE: 'ResponseInvalidPhone',
  RESPONSE_TRIP_HAS_LCC_FLIGHT: 'ResponseTripHasLccFlight',
  RESPONSE_ERROR_TRIP_WITHIN_24HRS: 'ResponseErrorTripWithin24Hrs',
  RESPONSE_INVALID_TRIP_IS_CRUISE: 'ResponseInvalidTripInCruise',
  CANCEL_FOR_FULL_REFUND: 'ResponseOnlyLodgingWithRefund',
  CANCEL_FOR_VOUCHER: 'ResponseOnlyLodgingWithCoupon',
  UNSUPPORTED: 'ResponseOnlyLodgingInEligible',
  NO_FLEX_POLICY_AVAILABLE: 'ResponseNoFlexAvailable',
});

export default ErrorCodes;
